export let USER_ERROR_ACTIONS = /*#__PURE__*/function (USER_ERROR_ACTIONS) {
  USER_ERROR_ACTIONS["SOMETHING_WENT_WRONG"] = "Oops, something went wrong";
  USER_ERROR_ACTIONS["INVOICE_COULD_NOT_SEND"] = "Sorry, we couldn't send you an invoice";
  USER_ERROR_ACTIONS["NOT_ENOUGH_CREDITS"] = "You have not enough credits";
  USER_ERROR_ACTIONS["DO_NOT_HAVE_PERMISSIONS"] = "Sorry, you do not have permission to do this.";
  return USER_ERROR_ACTIONS;
}({});